import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { LegalNotice } from 'cpie-common';
import { fetchLegalNotice } from './LegalNoticeSlice';
import { LegalNoticeContentSelector } from './LegalNoticeContentSelector';

export function useLegalNotice(): AbstractContentState<LegalNotice> {
    return useCmsContent(fetchLegalNotice, LegalNoticeContentSelector);
}
